module.exports = __webpack_public_path__ + "img/Screenshot_LYVE.229a34e7.svg";